// v1 do Dashboard Comercial só soma negociações em BRL (spec 143 Parte C).
export const formatCurrencyBRL = value =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    Number(value) || 0
  );

// Recebe segundos (vindos do backend) e devolve "Xd Yh" / "Yh" / "—" (zero).
export const formatDuration = totalSeconds => {
  const seconds = Number(totalSeconds) || 0;
  if (seconds <= 0) return '—';

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);

  if (days > 0) return `${days}d ${hours}h`;
  return `${hours}h`;
};

// Campos de UTM/tracking da Negociação usados como filtro (global e o da seção
// Origem das vendas) — mesma lista de UTM_FILTER_KEYS no backend.
export const UTM_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_adset',
  'utm_term',
  'utm_content',
  'campaign_id',
  'adset_id',
  'content_id',
  'ad_id',
  'utm_channel',
  'utm_matchtype',
  'fbclid',
  'gclid',
  'ctwa_clid',
  'lead_id',
  'gbraid',
  'wbraid',
  'fbc',
  'fbp',
  'client_ip_address',
  'client_user_agent',
  'event_id',
  'ga_client_id',
];
